<template>
  <div class="page">
    <img
      src="https://ica.obs.cn-south-1.myhuaweicloud.com/guangai/%E7%AE%A1%E9%81%931x.png"
      alt=""
      class="gd"
    />
    <img
      src="https://ica.obs.cn-south-1.myhuaweicloud.com/guangai/%E6%B0%B4%E6%B1%A0.png"
      class="sc"
      alt=""
    />

    <!-- 搅拌桶 -->
    <div class="">
      <img
        :src="
          deviceStatus.fA
            ? 'https://ica.obs.cn-south-1.myhuaweicloud.com/guangai/%E6%90%85%E6%8B%8C%E6%A1%B6%E8%BF%90%E8%A1%8C.png'
            : 'https://ica.obs.cn-south-1.myhuaweicloud.com/guangai/%E6%90%85%E6%8B%8C%E6%A1%B6.png'
        "
        class="jbt abs1"
        style=""
        alt=""
      />
      <img
        :src="
          deviceStatus.fB
            ? 'https://ica.obs.cn-south-1.myhuaweicloud.com/guangai/%E6%90%85%E6%8B%8C%E6%A1%B6%E8%BF%90%E8%A1%8C.png'
            : 'https://ica.obs.cn-south-1.myhuaweicloud.com/guangai/%E6%90%85%E6%8B%8C%E6%A1%B6.png'
        "
        class="jbt abs2"
        style=""
        alt=""
      />
      <img
        :src="
          deviceStatus.fC
            ? 'https://ica.obs.cn-south-1.myhuaweicloud.com/guangai/%E6%90%85%E6%8B%8C%E6%A1%B6%E8%BF%90%E8%A1%8C.png'
            : 'https://ica.obs.cn-south-1.myhuaweicloud.com/guangai/%E6%90%85%E6%8B%8C%E6%A1%B6.png'
        "
        class="jbt abs3"
        style=""
        alt=""
      />
    </div>

    <!-- 运行线 -->
    <div class="xian" v-if="deviceStatus.ggb">
      <!--灌溉线1 -->
      <img
        src="https://ica.obs.cn-south-1.myhuaweicloud.com/guangai/%E7%81%8C%E6%BA%89%E8%BF%90%E8%A1%8C1.png"
        class="ggb1"
        alt=""
        v-if="deviceStatus.ggb"
      />
      <!--灌溉线2 -->
      <img
        src="https://ica.obs.cn-south-1.myhuaweicloud.com/guangai/%E7%81%8C%E6%BA%89%E8%BF%90%E8%A1%8C.png"
        class="ggb2"
        alt=""
        v-if="deviceStatus.ggb"
      />

      <!-- 搅拌 -->
      <img
        class="jbg1"
        src="https://ica.obs.cn-south-1.myhuaweicloud.com/guangai/%E6%90%85%E6%8B%8C%E7%BD%90%E7%BA%BF01.png"
        v-if="deviceStatus.zffA && deviceStatus.zfb"
        alt=""
      />
      <img
        class="jbg2"
        src="https://ica.obs.cn-south-1.myhuaweicloud.com/guangai/%E6%90%85%E6%8B%8C%E7%BD%90%E7%BA%BF03.png"
        v-if="deviceStatus.zffB && deviceStatus.zfb"
        alt=""
      />
      <img
        class="jbg3"
        src="https://ica.obs.cn-south-1.myhuaweicloud.com/guangai/%E6%90%85%E6%8B%8C%E7%BD%90%E7%BA%BF04.png"
        v-if="deviceStatus.zffC && deviceStatus.zfb"
        alt=""
      />
      <!-- 反向 -->
      <!-- <img
        class="jbg1"
        src="https://ica.obs.cn-south-1.myhuaweicloud.com/guangai/00c.png"
        v-if="deviceStatus.zffA && !deviceStatus.zfb"
        alt=""
      />
      <img
        class="jbg2"
        src="https://ica.obs.cn-south-1.myhuaweicloud.com/guangai/00b.png"
        v-if="deviceStatus.zffB && !deviceStatus.zfb"
        alt=""
      />
      <img
        class="jbg3"
        src="https://ica.obs.cn-south-1.myhuaweicloud.com/guangai/00a.png"
        v-if="deviceStatus.zffC && !deviceStatus.zfb"
        alt=""
      /> -->
      <div class="jbg4" v-if="deviceStatus.zffA && deviceStatus.zfb"></div>
      <!-- <div
        class="jbg4 jbg4back"
        v-if="deviceStatus.zffA && !deviceStatus.zfb"
      ></div> -->
      <div class="jbg5" v-if="deviceStatus.zffB && deviceStatus.zfb"></div>
      <!-- <div
        class="jbg5 jbg5back"
        v-if="deviceStatus.zffB && !deviceStatus.zfb"
      ></div> -->
      <div class="jbg6" v-if="deviceStatus.zffC && deviceStatus.zfb"></div>
      <!-- <div
        class="jbg6 jbg6back"
        v-if="deviceStatus.zffC && !deviceStatus.zfb"
      ></div> -->
      <div
        class="jbg7"
        v-if="
          deviceStatus.zfb 
        "
      ></div>
      <!-- ||
          deviceStatus.zffA ||
          deviceStatus.zffB ||
          deviceStatus.zffC -->
      <div
        class="jbg8"
        v-if="deviceStatus.zfb "
      ></div>  <!-- || deviceStatus.zffB || deviceStatus.zffC -->
      
      <div class="jbg9" v-if="deviceStatus.zfb "></div>  <!-- || deviceStatus.zffC -->
      <div class="jbg10" v-if="deviceStatus.zfb"></div>
      <div class="jbg11" v-if="deviceStatus.zfb"></div>

      <!-- 灌溉 -->
      <div class="ggq">
        <div class="dx0 dxbg"></div>
        <div
          class="xx1 xxbg"
          v-if="
            deviceStatus.plot10 ||
            deviceStatus.plot11 ||
            deviceStatus.plot9 ||
            deviceStatus.plot8 ||
            deviceStatus.plot7 ||
            deviceStatus.plot6 ||
            deviceStatus.plot5 ||
            deviceStatus.plot4 ||
            deviceStatus.plot3 ||
            deviceStatus.plot2
          "
        ></div>
        <div class="dx1 dxbg" v-if="deviceStatus.plot1"></div>
        <div class="ggq1 ggqbg" v-if="deviceStatus.plot1"></div>
        <div
          class="ggqcheck ggq1check"
          @click="deviceStatus.plot1 = !deviceStatus.plot1"
        ></div>
        <div
          class="ggqcheck ggq2check"
          @click="deviceStatus.plot2 = !deviceStatus.plot2"
        ></div>
        <div
          class="ggqcheck ggq3check"
          @click="deviceStatus.plot3 = !deviceStatus.plot3"
        ></div>
        <div
          class="ggqcheck ggq4check"
          @click="deviceStatus.plot4 = !deviceStatus.plot4"
        ></div>
        <div
          class="ggqcheck ggq5check"
          @click="deviceStatus.plot5 = !deviceStatus.plot5"
        ></div>
        <div
          class="ggqcheck ggq6check"
          @click="deviceStatus.plot6 = !deviceStatus.plot6"
        ></div>
        <div
          class="ggqcheck ggq7check"
          @click="deviceStatus.plot7 = !deviceStatus.plot7"
        ></div>
        <div
          class="ggqcheck ggq8check"
          @click="deviceStatus.plot8 = !deviceStatus.plot8"
        ></div>
        <div
          class="ggqcheck ggq9check"
          @click="deviceStatus.plot9 = !deviceStatus.plot9"
        ></div>
        <div
          class="ggqcheck ggq10check"
          @click="deviceStatus.plot10 = !deviceStatus.plot10"
        ></div>
        <div
          class="ggqcheck ggq11check"
          @click="deviceStatus.plot11 = !deviceStatus.plot11"
        ></div>

        <div
          class="xx2 xxbg"
          v-if="
            deviceStatus.plot10 ||
            deviceStatus.plot11 ||
            deviceStatus.plot9 ||
            deviceStatus.plot8 ||
            deviceStatus.plot7 ||
            deviceStatus.plot6 ||
            deviceStatus.plot5 ||
            deviceStatus.plot4 ||
            deviceStatus.plot3
          "
        ></div>
        <div class="dx2 dxbg" v-if="deviceStatus.plot2"></div>
        <div class="ggq2 ggqbg" v-if="deviceStatus.plot2"></div>
        <div
          class="xx3 xxbg"
          v-if="
            deviceStatus.plot10 ||
            deviceStatus.plot11 ||
            deviceStatus.plot9 ||
            deviceStatus.plot8 ||
            deviceStatus.plot7 ||
            deviceStatus.plot6 ||
            deviceStatus.plot5 ||
            deviceStatus.plot4
          "
        ></div>
        <div class="dx3 dxbg" v-if="deviceStatus.plot3"></div>
        <div class="ggq3 ggqbg" v-if="deviceStatus.plot3"></div>
        <div
          class="xx4 xxbg"
          v-if="
            deviceStatus.plot10 ||
            deviceStatus.plot11 ||
            deviceStatus.plot9 ||
            deviceStatus.plot8 ||
            deviceStatus.plot7 ||
            deviceStatus.plot6 ||
            deviceStatus.plot5
          "
        ></div>
        <div class="dx4 dxbg" v-if="deviceStatus.plot4"></div>
        <div class="ggq4 ggqbg" v-if="deviceStatus.plot4"></div>
        <div
          class="xx5 xxbg"
          v-if="
            deviceStatus.plot10 ||
            deviceStatus.plot11 ||
            deviceStatus.plot9 ||
            deviceStatus.plot8 ||
            deviceStatus.plot7 ||
            deviceStatus.plot6
          "
        ></div>
        <div class="dx5 dxbg" v-if="deviceStatus.plot5"></div>
        <div class="ggq5 ggqbg" v-if="deviceStatus.plot5"></div>

        <div
          class="xx6 xxbg"
          v-if="
            deviceStatus.plot10 ||
            deviceStatus.plot11 ||
            deviceStatus.plot9 ||
            deviceStatus.plot8 ||
            deviceStatus.plot7
          "
        ></div>
        <div class="dx6 dxbg" v-if="deviceStatus.plot6"></div>
        <div class="ggq6 ggqbg" v-if="deviceStatus.plot6"></div>

        <div
          class="xx7 xxbg"
          v-if="
            deviceStatus.plot10 ||
            deviceStatus.plot11 ||
            deviceStatus.plot9 ||
            deviceStatus.plot8
          "
        ></div>
        <div class="dx7 dxbg" v-if="deviceStatus.plot7"></div>
        <div class="ggq7 ggqbg" v-if="deviceStatus.plot7"></div>

        <div
          class="xx8 xxbg"
          v-if="
            deviceStatus.plot10 || deviceStatus.plot11 || deviceStatus.plot9
          "
        ></div>
        <div class="dx8 dxbg" v-if="deviceStatus.plot8"></div>
        <div class="ggq8 ggqbg" v-if="deviceStatus.plot8"></div>

        <div
          class="xx9 xxbg"
          v-if="deviceStatus.plot10 || deviceStatus.plot11"
        ></div>
        <div class="dx9 dxbg" v-if="deviceStatus.plot9"></div>
        <div class="ggq9 ggqbg" v-if="deviceStatus.plot9"></div>

        <div class="xx10 xxbg" v-if="deviceStatus.plot11"></div>
        <div class="dx10 dxbg" v-if="deviceStatus.plot10"></div>
        <div class="ggq10 ggqbg" v-if="deviceStatus.plot10"></div>

        <div class="dx11 dxbg" v-if="deviceStatus.plot11"></div>
        <div class="ggq11 ggqbg" v-if="deviceStatus.plot11"></div>
      </div>
    </div>

    <!-- 标注 -->
    <div class="bz">
      <img
        src="https://ica.obs.cn-south-1.myhuaweicloud.com/guangai/%E7%81%8C%E6%BA%89%E6%B3%B5%402x.png"
        class="ggb"
        alt=""
      />
      <div class="flexCol alit liuliang">
        <div class="">流量</div>
        <div class="info">8.88</div>
      </div>

      <div class="flexCol alit yali">
        <div class="">压力</div>
        <div class="info">8.88</div>
      </div>
      <img
        src="https://ica.obs.cn-south-1.myhuaweicloud.com/guangai/%E8%BF%87%E6%BB%A4%E7%B3%BB%E7%BB%9F%402x.png"
        class="glxt"
        alt=""
      />
      <img
        src="https://ica.obs.cn-south-1.myhuaweicloud.com/guangai/%E7%A2%9F%E7%89%87%402x.png"
        class="dp"
        alt=""
      />
      <img
        src="https://ica.obs.cn-south-1.myhuaweicloud.com/guangai/%E7%A2%9F%E7%89%87.png"
        class="dpcont"
        alt=""
      />
      <img
        src="https://ica.obs.cn-south-1.myhuaweicloud.com/guangai/%E6%B3%A8%E8%82%A5%E9%98%80%402x.png"
        class="zff"
        alt=""
      />
      <img
        src="https://ica.obs.cn-south-1.myhuaweicloud.com/guangai/%E6%B3%A8%E8%82%A5%E6%B3%B5%402x.png"
        class="zfb"
        alt=""
      />
    </div>

    <div class="bottom-infos flex justc">
      <div class="">PH值：9.07</div>
      <div class="" style="margin: 0 60px">EC值：0.0</div>
      <div class="">水温：24.8°C</div>
    </div>
    <div class=""></div>

    <div class="jbinfo">
      <div class="jbinfo1">
        <div class="jbinfostyle flexCol alit" style="margin-left: 10px">
          <div class="jindu">60%</div>
          <div class="tiao-out">
            <div class="tiao-in"></div>
          </div>
        </div>
        <div class="jbinfostyle" style="margin-left: 5px">
          <a style="color: #16e1ff">200</a>&nbsp;&nbsp;&nbsp;L
        </div>
        <div class="jbinfostyle" style="font-size: 13px">
          瞬时流量:<a style="color: #16e1ff">200</a>L/H
        </div>
      </div>

      <div class="jbinfo2">
        <div class="jbinfostyle flexCol alit">
          <div class="jindu">60%</div>
          <div class="tiao-out">
            <div class="tiao-in"></div>
          </div>
        </div>
        <div class="jbinfostyle" style="margin-left: 5px">
          <a style="color: #16e1ff">200</a>&nbsp;&nbsp;&nbsp;L
        </div>
        <div class="jbinfostyle" style="font-size: 13px; margin-left: 10px">
          瞬时流量:<a style="color: #16e1ff">200</a>L/H
        </div>
      </div>

      <div class="jbinfo3">
        <div class="jbinfostyle flexCol alit">
          <div class="jindu">60%</div>
          <div class="tiao-out">
            <div class="tiao-in"></div>
          </div>
        </div>
        <div class="jbinfostyle" style="margin-left: 15px">
          <a style="color: #16e1ff">200</a>&nbsp;&nbsp;&nbsp;L
        </div>
        <div class="jbinfostyle" style="font-size: 13px; margin-left: 30px">
          瞬时流量:<a style="color: #16e1ff">200</a>L/H
        </div>
      </div>
    </div>

    <div class="flex alit topbutton">
      <div class="button flex alit justc buttoncheck">
        手动模式
        <img
          src="https://ica.obs.cn-south-1.myhuaweicloud.com/guangai/%E6%A8%A1%E5%BC%8F%E5%BC%80%E5%90%AF%402x.png"
          style=""
          alt=""
        />
      </div>
      <!-- <div class="button flex alit justc buttondefault">
        灌溉模式
        <img
          src="https://ica.obs.cn-south-1.myhuaweicloud.com/guangai/%E6%A8%A1%E5%BC%8F%E5%85%B3%E9%97%AD%402x.png"
          style=""
          alt=""
        />
      </div> -->
      <div class="button flex alit justc buttondefault">
        注肥模式
        <img
          src="https://ica.obs.cn-south-1.myhuaweicloud.com/guangai/%E6%A8%A1%E5%BC%8F%E5%85%B3%E9%97%AD%402x.png"
          style=""
          alt=""
        />
      </div>
    </div>

    <div class="water-data flexCol justb">
      <div class="flex justb">
        <div class="" style="width: 30%">类别</div>
        <div class="" style="width: 35%">瞬时流量</div>
        <div class="" style="width: 30%">操作</div>
      </div>
      <div class="flex justb">
        <div class="" style="width: 30%">总量</div>
        <div class="" style="width: 35%">88.6L/H</div>
        <div class="ql" style="width: 30%">清零</div>
      </div>
    </div>

    <!-- 操作按钮 -->
    <!-- 灌溉泵 -->
    <div class="ggb-button">
      <img
        src="https://ica.obs.cn-south-1.myhuaweicloud.com/guangai/%E6%A8%A1%E5%BC%8F%E5%85%B3%E9%97%AD%402x.png"
        class="cz-button"
        v-if="!deviceStatus.ggb"
        @click="deviceStatus.ggb = true"
        alt=""
      />
      <img
        src="https://ica.obs.cn-south-1.myhuaweicloud.com/guangai/%E6%A8%A1%E5%BC%8F%E5%BC%80%E5%90%AF%402x.png"
        class="cz-button"
        v-else
        @click="deviceStatus.ggb = false"
        alt=""
      />
    </div>

    <!-- 注肥泵 -->
    <div class="zfb-button">
      <img
        src="https://ica.obs.cn-south-1.myhuaweicloud.com/guangai/%E6%A8%A1%E5%BC%8F%E5%85%B3%E9%97%AD%402x.png"
        class="cz-button"
        v-if="!deviceStatus.zfb"
        @click="deviceStatus.zfb = true"
        alt=""
      />
      <img
        src="https://ica.obs.cn-south-1.myhuaweicloud.com/guangai/%E6%A8%A1%E5%BC%8F%E5%BC%80%E5%90%AF%402x.png"
        class="cz-button"
        v-else
        @click="deviceStatus.zfb = false"
        alt=""
      />
    </div>

    <!-- 注肥阀 -->
    <div class="zff-switch">
      <!-- <el-switch
        v-model="deviceStatus.zffA"
        active-color="#01D356"
        active-text="on"
        inactive-text="off"
        inactive-color="#ff4949"
        class="switch1"
      >
      </el-switch>
      <el-switch
        v-model="deviceStatus.zffB"
        active-color="#01D356"
        active-text="on"
        inactive-text="off"
        inactive-color="#ff4949"
        class="switch2"
      >
      </el-switch>
      <el-switch
        v-model="deviceStatus.zffC"
        active-color="#01D356"
        active-text="on"
        inactive-text="off"
        inactive-color="#ff4949"
        class="switch3"
      >
      </el-switch> -->

      <div class="flexCol alit switch4">
        <div class="" style="margin-bottom: 10px">A肥</div>
        <el-switch
          v-model="deviceStatus.fA"
          active-color="#01D356"
          active-text="on"
          inactive-text="off"
          inactive-color="#ff4949"
        >
        </el-switch>
      </div>

      <div class="flexCol alit switch5">
        <div class="" style="margin-bottom: 10px">B肥</div>
        <el-switch
          v-model="deviceStatus.fB"
          active-color="#01D356"
          active-text="on"
          inactive-text="off"
          inactive-color="#ff4949"
        >
        </el-switch>
      </div>
      <div class="flexCol alit switch6">
        <div class="" style="margin-bottom: 10px">C肥</div>
        <el-switch
          v-model="deviceStatus.fC"
          active-color="#01D356"
          active-text="on"
          inactive-text="off"
          inactive-color="#ff4949"
        >
        </el-switch>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value: "",
      deviceStatus: {
        ggb: true, //灌溉泵
        fA: true, //注肥桶A
        fB: true, //注肥桶B
        fC: true, //注肥桶C
        zffA: true, //注肥阀A
        zffB: true, //注肥阀B
        zffC: true, //注肥阀C
        zfb: true, //注肥泵
        plot1: true, //地块
        plot2: false,
        plot3: true,
        plot4: true,
        plot5: true,
        plot6: false,
        plot7: false,
        plot8: false,
        plot9: false,
        plot10: false,
        plot11: false,
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.page {
  width: 1600px;
  height: 800px;
  background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/guangai/%E8%83%8C%E6%99%AF%402x.png");
  background-size: 100% 100%;
  border-radius: 20px;
  position: relative;
  .zff-switch {
    font-family: Source Han Sans CN;
    font-weight: bold;
    font-size: 18px;
    color: #49c5ff;
    .switch1 {
      position: absolute;
      left: 500px;
      top: 360px;
      z-index: 20;
    }
    .switch2 {
      position: absolute;
      left: 740px;
      top: 320px;
      z-index: 20;
    }
    .switch3 {
      position: absolute;
      left: 885px;
      top: 320px;
      z-index: 20;
    }

    .switch4 {
      position: absolute;
      left: 690px;
      top: 120px;
      z-index: 20;
    }

    .switch5 {
      position: absolute;
      left: 820px;
      top: 120px;
      z-index: 20;
    }

    .switch6 {
      position: absolute;
      left: 960px;
      top: 120px;
      z-index: 20;
    }
  }

  .cz-button {
    width: 57px;
    height: 59px;
  }
  .zfb-button {
    position: absolute;
    right: 562px;
    bottom: 156px;
    z-index: 20;
    cursor: pointer;
  }
  .ggb-button {
    position: absolute;
    left: 273px;
    top: 420px;
    z-index: 20;
    cursor: pointer;
  }
  .water-data {
    width: 210px;
    height: 100px;
    background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/guangai/%E6%B0%B4%E8%82%A5%E6%9C%BA%E6%95%B0%E6%8D%AE%402x.png");
    background-size: 100% 100%;
    position: absolute;
    top: 110px;
    right: 30px;
    padding: 25px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    font-size: 16px;
    color: #2fa8f5;
    text-align: center;
    z-index: 20;
    .ql {
      width: 58px;
      height: 32px;
      background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/guangai/%E6%B8%85%E9%9B%B6%402x.png");
      background-size: 100% 100%;
      text-align: center;
      line-height: 32px;

      font-family: Source Han Sans CN;
      font-weight: bold;
      font-size: 14px;
      color: #ffffff;
      cursor: pointer;
    }
  }
  .topbutton {
    position: absolute;
    top: 30px;
    right: 30px;
    z-index: 20;
    .button {
      width: 172px;
      height: 60px;
      background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/guangai/%E9%A1%B6%E9%83%A8%E6%8C%89%E9%92%AE%402x.png");
      background-size: 100% 100%;
      cursor: pointer;
      img {
        width: 41px;
        height: 41px;
        margin-left: 16px;
      }
    }

    .buttoncheck {
      font-family: Source Han Sans CN;
      font-weight: bold;
      font-size: 18px;
      color: #06b6ff;
    }
    .buttondefault {
      font-family: Source Han Sans CN;
      font-weight: bold;
      font-size: 18px;
      color: #ffffff;
    }
  }

  .jbinfo {
    .jindu {
      width: 42px;
      height: 24px;
      background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/guangai/%E6%B5%81%E9%87%8F%E5%8E%8B%E5%8A%9B%402x.png");
      background-size: 100% 100%;
      font-family: Source Han Sans CN;
      font-weight: bold;
      font-size: 12px;
      color: #ffffff;
      margin-bottom: 2px;
      margin-top: 6px;
      text-align: center;
      line-height: 16px;
    }
    .tiao-out {
      width: 90px;
      .tiao-in {
        width: 60%;
        height: 6px;
        background: linear-gradient(90deg, #1483ff, #00f0ff);
        border-radius: 3px;
      }
    }
    .jbinfo1 {
      position: absolute;
      left: 580px;
      top: 350px;
      z-index: 20;
      .jbinfostyle {
        width: 120px;
        height: 51px;
        background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/guangai/A%E6%A0%B7%E5%BC%8F%402x.png");
        background-size: 100% 100%;

        font-family: Source Han Sans CN;
        font-weight: bold;
        font-size: 18px;
        color: #ffffff;
        text-align: center;
        line-height: 40px;
      }
    }

    .jbinfo2 {
      position: absolute;
      left: 760px;
      top: 350px;
      z-index: 20;
      .jbinfostyle {
        width: 120px;
        height: 51px;
        background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/guangai/B%E6%A0%B7%E5%BC%8F%402x.png");
        background-size: 100% 100%;

        font-family: Source Han Sans CN;
        font-weight: bold;
        font-size: 18px;
        color: #ffffff;
        text-align: center;
        line-height: 40px;
      }
    }

    .jbinfo3 {
      position: absolute;
      left: 910px;
      top: 340px;
      z-index: 12;
      .jbinfostyle {
        width: 120px;
        height: 51px;
        background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/guangai/C%E6%A0%B7%E5%BC%8F%402x.png");
        background-size: 100% 100%;

        font-family: Source Han Sans CN;
        font-weight: bold;
        font-size: 18px;
        color: #ffffff;
        text-align: center;
        line-height: 40px;
      }
    }
  }
  .bottom-infos {
    position: absolute;
    bottom: 140px;
    left: 500px;
    width: 520px;
    height: 63px;
    background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/guangai/%E5%BA%95%E9%83%A8%E4%BF%A1%E6%81%AF%402x.png");
    background-size: 100% 100%;
    line-height: 50px;
    font-weight: bold;
    font-size: 18px;
    color: #49c5ff;
  }
  .bz {
    .liuliang {
      font-family: Source Han Sans CN;
      font-weight: bold;
      font-size: 18px;
      color: #ffffff;
      position: absolute;
      left: 325px;
      top: 325px;
      z-index: 12;
      .info {
        width: 65px;
        height: 43px;
        background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/guangai/%E6%B5%81%E9%87%8F%E5%8E%8B%E5%8A%9B%402x.png");
        background-size: 100% 100%;
        text-align: center;
        line-height: 35px;
        margin-top: 5px;
      }
    }
    .yali {
      font-family: Source Han Sans CN;
      font-weight: bold;
      font-size: 18px;
      color: #ffffff;
      position: absolute;
      left: 392px;
      top: 325px;
      z-index: 12;
      .info {
        width: 65px;
        height: 43px;
        background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/guangai/%E6%B5%81%E9%87%8F%E5%8E%8B%E5%8A%9B%402x.png");
        background-size: 100% 100%;
        text-align: center;
        line-height: 35px;
        margin-top: 5px;
      }
    }
    .ggb {
      position: absolute;
      left: 150px;
      top: 340px;
      width: 130px;
      height: 47px;
      z-index: 12;
    }
    .glxt {
      position: absolute;
      left: 36px;
      bottom: 250px;
      width: 130px;
      height: 47px;
      z-index: 12;
    }
    .dp {
      position: absolute;
      left: 115px;
      bottom: 125px;
      width: 130px;
      height: 47px;
      z-index: 12;
    }
    .dpcont {
      position: absolute;
      left: 226px;
      bottom: 107px;
      width: 138px;
      height: 99px;
      z-index: 12;
    }
    .zff {
      position: absolute;
      left: 520px;
      top: 305px;
      width: 93px;
      height: 50px;
      z-index: 12;
    }
    .zfb {
      position: absolute;
      right: 445px;
      bottom: 255px;
      width: 120px;
      height: 47px;
      z-index: 12;
    }
  }
  .xian {
    .ggq {
      .dx0 {
        bottom: 133px;
        right: 350px;
        width: 86px;
        height: 16px;
      }
      .xx1 {
        bottom: 132px;
        right: 350px;
        width: 52px;
        height: 90px;
      }
      .dx1 {
        bottom: 134px;
        right: 270px;
        width: 86px;
        height: 16px;
      }
      .xx2 {
        bottom: 220px;
        right: 392px;
        width: 45px;
        height: 70px;
      }
      .dx2 {
        bottom: 212px;
        right: 322px;
        width: 76px;
        height: 16px;
      }
      .xx3 {
        bottom: 285px;
        right: 427px;
        width: 40px;
        height: 62px;
      }
      .dx3 {
        bottom: 281px;
        right: 362px;
        width: 70px;
        height: 16px;
      }
      .xx4 {
        bottom: 342px;
        right: 455px;
        width: 40px;
        height: 58px;
      }
      .dx4 {
        bottom: 337px;
        right: 398px;
        width: 66px;
        height: 16px;
      }
      .xx5 {
        bottom: 396px;
        right: 478px;
        width: 40px;
        height: 48px;
      }
      .dx5 {
        bottom: 389px;
        right: 430px;
        width: 60px;
        height: 16px;
      }
      .xx6 {
        bottom: 439px;
        right: 489px;
        width: 49px;
        height: 44px;
      }
      .dx6 {
        bottom: 433px;
        right: 456px;
        width: 56px;
        height: 16px;
      }
      .xx7 {
        bottom: 480px;
        right: 505px;
        width: 49px;
        height: 35px;
      }
      .dx7 {
        bottom: 473px;
        right: 480px;
        width: 52px;
        height: 16px;
      }
      .xx8 {
        bottom: 510px;
        right: 540px;
        width: 30px;
        height: 36px;
      }
      .dx8 {
        bottom: 504px;
        right: 500px;
        width: 48px;
        height: 16px;
      }
      .xx9 {
        bottom: 540px;
        right: 554px;
        width: 30px;
        height: 32px;
      }
      .dx9 {
        bottom: 534px;
        right: 518px;
        width: 45px;
        height: 16px;
      }
      .xx10 {
        bottom: 564px;
        right: 568px;
        width: 30px;
        height: 34px;
      }
      .dx10 {
        bottom: 562px;
        right: 532px;
        width: 46px;
        height: 16px;
      }

      .dx11 {
        bottom: 589px;
        right: 550px;
        width: 46px;
        height: 16px;
      }

      .xxbg {
        position: absolute;
        z-index: 12;
        overflow: hidden;
        background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/guangai/%E6%96%9C%E7%BA%BF.png");
        background-size: 49px 82px;
        background-repeat: no-repeat;
      }

      .dxbg {
        position: absolute;
        z-index: 12;
        overflow: hidden;
        background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/guangai/%E7%9F%AD%E7%BA%BF.png");
        background-size: 92px 16px;
        background-repeat: no-repeat;
      }

      .ggq1 {
        right: 130px;
        bottom: 120px;
      }
      .ggqcheck {
        cursor: pointer;
        position: absolute;
        z-index: 14;
      }
      .ggq1check {
        width: 220px;
        height: 100px;
        right: 74px;
        bottom: 90px;
      }
      .ggq2check {
        width: 200px;
        height: 75px;
        right: 140px;
        bottom: 190px;
      }
      .ggq3check {
        width: 180px;
        height: 60px;
        right: 200px;
        bottom: 265px;
      }
      .ggq4check {
        width: 165px;
        height: 55px;
        right: 250px;
        bottom: 325px;
      }
      .ggq5check {
        width: 150px;
        height: 47px;
        right: 290px;
        bottom: 380px;
      }
      .ggq6check {
        width: 135px;
        height: 38px;
        right: 330px;
        bottom: 427px;
      }
      .ggq7check {
        width: 128px;
        height: 35px;
        right: 360px;
        bottom: 465px;
      }
      .ggq8check {
        width: 118px;
        height: 33px;
        right: 390px;
        bottom: 500px;
      }
      .ggq9check {
        width: 110px;
        height: 29px;
        right: 415px;
        bottom: 533px;
      }
      .ggq10check {
        width: 104px;
        height: 26px;
        right: 436px;
        bottom: 562px;
      }
      .ggq11check {
        width: 95px;
        height: 26px;
        right: 461px;
        bottom: 588px;
      }
      .ggq2 {
        right: 180px;
        bottom: 200px;
      }
      .ggq3 {
        right: 230px;
        bottom: 260px;
        transform: scale(0.95);
      }
      .ggq4 {
        right: 265px;
        bottom: 320px;
        transform: scale(0.9);
      }
      .ggq5 {
        right: 308px;
        bottom: 370px;
        transform: scale(0.8);
      }
      .ggq6 {
        right: 340px;
        bottom: 410px;
        transform: scale(0.7);
      }
      .ggq7 {
        right: 370px;
        bottom: 448px;
        transform: scale(0.6);
      }
      .ggq8 {
        right: 390px;
        bottom: 484px;
        transform: scale(0.6);
      }
      .ggq9 {
        right: 415px;
        bottom: 510px;
        transform: scale(0.5);
      }
      .ggq10 {
        right: 432px;
        bottom: 538px;
        transform: scale(0.45);
      }
      .ggq11 {
        right: 452px;
        bottom: 562px;
        transform: scale(0.4);
      }
      .ggqbg {
        position: absolute;
        z-index: 12;
        background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/guangai/%E7%81%8C%E6%BA%89%E5%8C%BA.png");
        background-size: 100% 100%;
        width: 140px;
        height: 80px;
      }
    }
    .jbg11 {
      background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/guangai/8.png");
      background-size: 200px 150px;
      background-repeat: no-repeat;
      background-position-x: -50px;
      position: absolute;
      bottom: 142px;
      left: 1042px;
      width: 140px;
      height: 105px;
      overflow: hidden;
      z-index: 12;
    }
    .jbg10 {
      background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/guangai/7.png");
      background-size: 90px 40px;
      background-repeat: no-repeat;
      position: absolute;
      bottom: 213px;
      left: 918px;
      width: 60px;
      height: 40px;
      overflow: hidden;
      z-index: 12;
    }
    .jbg9 {
      background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/guangai/6.png");
      background-size: 310px 40px;
      background-repeat: no-repeat;
      position: absolute;
      bottom: 212px;
      left: 712px;
      width: 220px;
      height: 40px;
      overflow: hidden;
      z-index: 12;
    }
    .jbg8 {
      background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/guangai/5.png");
      background-size: 310px 40px;
      background-repeat: no-repeat;
      position: absolute;
      bottom: 218px;
      left: 509px;
      width: 220px;
      height: 40px;
      overflow: hidden;
      z-index: 12;
    }
    .jbg7 {
      background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/guangai/4.png");
      background-size: 220px 175px;
      background-repeat: no-repeat;
      background-position-x: -10px;
      position: absolute;
      bottom: 103px;
      left: 359px;
      width: 164px;
      height: 140px;
      overflow: hidden;
      z-index: 12;
    }
    .jbg6 {
      background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/guangai/3.png");
      background-size: 80px 270px;
      background-repeat: no-repeat;
      background-position-x: -10px;
      position: absolute;
      bottom: 236px;
      left: 901px;
      width: 50px;
      height: 132px;
      overflow: hidden;
      z-index: 12;
    }
    .jbg6back {
      transform: rotate(180deg);
      bottom: 237px !important;
      left: 880px !important;
    }
    .jbg5 {
      background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/guangai/2.png");
      background-size: 40px 270px;
      background-repeat: no-repeat;
      position: absolute;
      bottom: 236px;
      left: 708px;
      width: 40px;
      height: 138px;
      overflow: hidden;
      z-index: 12;
    }
    .jbg5back {
      transform: rotate(180deg);
      bottom: 228px !important;
      left: 709px !important;
    }
    .jbg4 {
      background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/guangai/1.png");
      background-size: 100px 260px;
      background-repeat: no-repeat;
      background-position-x: -50px;
      position: absolute;
      bottom: 236px;
      left: 522.5px;
      width: 50px;
      height: 138px;
      overflow: hidden;
      z-index: 12;
    }
    .jbg4back {
      transform: rotate(180deg) !important;
      bottom: 230px !important;
      left: 507.5px !important;
    }
    .jbg3 {
      position: absolute;
      bottom: 444px;
      left: 856px;
      width: 44px;
      height: 84px;
      z-index: 12;
    }
    .jbg2 {
      position: absolute;
      bottom: 444px;
      left: 718px;
      width: 44px;
      height: 84px;
      z-index: 12;
    }
    .jbg1 {
      position: absolute;
      bottom: 438px;
      left: 570px;
      width: 60px;
      height: 91px;
      z-index: 12;
    }
    .ggb1 {
      position: absolute;
      bottom: 375px;
      left: 204px;
      width: 153px;
      height: 190px;
      z-index: 12;
    }
    .ggb2 {
      width: 1164px;
      height: 338px;
      position: absolute;
      bottom: 83px;
      left: 49px;
      z-index: 12;
    }
  }
  .jbt {
    width: 200px;
    height: 200px;
    position: absolute;

    z-index: 13;
  }
  .abs1 {
    left: 570px;
    top: 145px;
  }
  .abs2 {
    left: 705px;
    top: 145px;
  }
  .abs3 {
    left: 840px;
    top: 145px;
  }
  .sc {
    width: 480px;
    height: 200px;
    position: absolute;
    left: 120px;
    top: 60px;
    z-index: 10;
  }
  .gd {
    width: 1500px;
    margin-left: 50px;
    z-index: 11;
    position: relative;
  }

  .el-switch__core {
    width: 64px !important;
    height: 32px !important;
    border-radius: 32px;
    border: none !important;
  }

  .el-switch__core:after {
    width: 32px !important;
    height: 32px !important;
    top: 0 !important;
  }
  .el-switch.is-checked .el-switch__core::after {
    margin-left: -32px !important;
  }

  .el-switch__label--left {
    position: absolute;
    left: 36px;
    color: #fff;
    z-index: -1111;
    cursor: default;
    user-select: none;
  }

  .el-switch__label--right {
    position: absolute;
    right: 36px;
    color: #fff;
    z-index: -1111;
    cursor: default;
    user-select: none;
  }

  .el-switch__label--right.is-active {
    z-index: 1111;
    color: #fff !important;
  }

  .el-switch__label--left.is-active {
    z-index: 1111;
    color: #fff !important;
  }
}
</style>